export const formataCpfCnpj = (cpfCnpj: string | number | null) => {
  if (!cpfCnpj) return null;

  if (String(cpfCnpj).length <= 11) {
    return String(cpfCnpj).padStart(11, '00000000000');
  } else {
    return String(cpfCnpj).padStart(14, '00000000000000');
  }
};
